module.exports = __webpack_public_path__ + "static/media/logo_SERDI.0c4356a0.svg";